<script>
import FavoriteTool from '../lib/favorite-tool.vue'
import VisitsTool from './visits-tool.vue'

export default {
    emits: ['search', 'delete-search'],
    components: {FavoriteTool, VisitsTool},
    props: {
        favKey: {type: String, required: true},
        favMode: {type: Boolean, required: true},
        filter: {type: Object, required: true},
        visitsActive: {type: Boolean, default: false},
        numVisits: {type: Number, default: 0},
    },
    data() {
        return {
            search: this.filter.search,
        }
    },

    computed: {
        favActive() { return this.filter.favorites },
    },

    methods: {
        rangeAtoZ() {
            let range = ['#']
            for (var i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); i++) {
                range.push(String.fromCharCode(i));
            }
            return range
        },
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },

        filterActive: function(letter) {
           return this.filter.company__name__gt == letter
        },
        toggleVisits() {
            this.$emit('toggle-visits', !this.visitsActive)
        }
    },
}
</script>

<template>
<div>
    <nav class="navbar bg-light px-3">
        <div class="d-flex flex-wrap align-items-center w-100 gap-2">
            <div class="d-flex align-items-center gap-1">
                <favorite-tool v-if="!favMode" :active="favActive" @click="$emit('toggle-favorites', !favActive)" />
                <visits-tool v-if="!favMode" :active="visitsActive" @click="toggleVisits()" />
                <button class="btn btn-sm btn-secondary"
                v-b-tooltip.hover title="Export List" @click.prevent="$emit('export-list')">
                    <i class="fas fa-download"></i>
                </button>
            </div>
            <form class="ms-auto" @submit.prevent="$emit('search', search)">
                <div class="d-flex flex-nowrap">
                <input class="form-control form-control-sm me-1" type="search" placeholder="Quick Search" v-model="search"
                @input="onSearchInput()">
                <button class="btn btn-sm btn-secondary">
                    <span class="fa fa-search"></span>
                </button>
                </div>
            </form>
        </div>
    </nav>
    <div class="d-flex flex-row flex-nowrap justify-content-around py-3">
        <b class="c-letter" v-for="letter in rangeAtoZ()" :key="letter"
         :class="{'c-underscore': filterActive(letter)}"
         @click="$emit('on-filter-value', letter)">{{ letter }}</b>
    </div>
</div>
</template>

<style scoped>
.nav-link {
    text-decoration: none;
}
.c-underscore {
    text-decoration: underline;
}

.c-letter {
    cursor: pointer;
}
</style>